import type { HttpClient } from '../client';
import type { UserProfile } from '../types/auth';

export interface DingTalkLoginRequest {
  /** JSAPI `dd.getAuthCode` 取到的免登 code。 */
  code: string;
}

export interface DingTalkLoginResult {
  token: string;
  tokenType: string;
  expiresInMinutes: number;
  profile: UserProfile;
  channel: string;
}

export interface DingTalkBindResult {
  bound: boolean;
  thirdType: string;
  userIdMask: string | null;
  orgId: string;
  boundAt: string;
}

/**
 * 钉钉企业内部微应用免登（复用小程序 H5 产物）。
 * 凭据为「待补充…」占位时后端返回 42200，前端应回落到账号口令登录。
 */
export function createDingTalkApi(http: HttpClient) {
  return {
    /** 免登：userid 已绑定则直接换 JWT。 */
    login(body: DingTalkLoginRequest): Promise<DingTalkLoginResult> {
      return http.request<DingTalkLoginResult>({ path: '/dingtalk/login', method: 'POST', body });
    },

    /** 已登录账号绑定钉钉 userid（换绑覆盖同 AppKey 的旧记录）。 */
    bind(body: DingTalkLoginRequest): Promise<DingTalkBindResult> {
      return http.request<DingTalkBindResult>({ path: '/dingtalk/bind', method: 'POST', body });
    }
  };
}

export type DingTalkApi = ReturnType<typeof createDingTalkApi>;
